import classnames from 'classnames';
import { compose, lifecycle, withProps } from 'recompose';
import React from 'react';
import {
  withGoogleMap,
  GoogleMap,
  OverlayView
} from 'react-google-maps';

import ErrorBoundary from '../shared/ErrorBoundary.jsx';

import newMapBounds from '../../services/MapsService';

const MAX_ZOOM = 12;

const filterMapVenue = result => !isNaN(result.lat) && !isNaN(result.lon);

const getResultsMapOptions = () => ({
  mapTypeControl: false,
  panControl: false,
  scrollwheel: false,
  streetViewControl: false,
  styles: [{
    stylers: [
      { visibility: 'simplified' },
      { saturation: -25 },
      { lightness: 25 }
    ]
  }],
  zoomControlOptions: { position: window.google.maps.ControlPosition.RIGHT_TOP }
});

const isOfferHighlighted = (id, highlightedOfferId) => id === highlightedOfferId;

function mapPane(id, highlightedOfferId) {
  return isOfferHighlighted(id, highlightedOfferId)
    ? OverlayView.FLOAT_PANE
    : OverlayView.OVERLAY_MOUSE_TARGET;
}

function renderOverlayResult(result) {
  const { handleMarkerClick, highlightedOfferId } = this;
  const id = `${result.slug}-${result.package._id}`;
  const markerClasses = classnames(
    'search-map__marker js-map-marker',
    isOfferHighlighted(id, highlightedOfferId) && 'is-highlighted'
  );

  return (
    <OverlayView
      key={id}
      mapPaneName={mapPane(id, highlightedOfferId)}
      position={new google.maps.LatLng(result.lat, result.lon)}
    >
      <div className={markerClasses} onClick={handleMarkerClick(id)}></div>
    </OverlayView>
  );
}

function renderOverlays(props) {
  return props.results.filter(filterMapVenue).map(renderOverlayResult.bind(props));
}

function setMapBounds(refs, results) {
  if (!results.length) { // should always have something, though
    return;
  }

  const bounds = newMapBounds(results);
  const { map } = refs;

  refs.bounds = bounds;
  map.fitBounds(bounds);
  refs.googleMap.setZoom(Math.min(map.getZoom(), MAX_ZOOM));
}

const AsyncResultsComponent = compose(
  withProps({
    // withGoogleMap props
    containerElement: <div style={{ height: "100%" }}></div>,
    mapElement: <div style={{ height: "100%" }}></div>
  }),
  lifecycle({
    UNSAFE_componentWillMount() {
      const self = this;
      const { props, state } = self;
      const onresize = () => {
        setMapBounds(self.state.refs, self.props.results);
      };

      if (!state || !state.refs) {
        self.setState({
          onresize,
          refs: {}
        });

        window.addEventListener('resize', onresize);
      }

      self.setState({
        onMapMounted: ref => {
          const { refs } = self.state;

          if (ref) {
            refs.googleMap = ref.context[Object.keys(ref.context)[0]];
            refs.map = ref;
          }

          setMapBounds(refs, props.results);
        }
      });
    },
    componentDidUpdate() {
      const zoomLevel = this.state.refs.map.getZoom();

      if (!zoomLevel) {
        this.state.onresize();
      }
    },
    componentWillUnmount() {
      window.removeEventListener("resize", this.state.onresize);
    }
  }),
  withGoogleMap
)(props => (
  <GoogleMap
    options={getResultsMapOptions()}
    ref={props.onMapMounted}
  >
    {props.results.length && renderOverlays(props)}
  </GoogleMap>
));

class AsyncResultsMap extends React.PureComponent {
  render() {
    return (
      <ErrorBoundary summary="An error occurred when trying to render the map">
        <AsyncResultsComponent {...this.props} />
      </ErrorBoundary>
    );
  }
}

export default AsyncResultsMap;



// WEBPACK FOOTER //
// ./components/search/AsyncResultsMap.jsx